export const color = (color) => {
    let HexColor = "";

    switch (color) {
      case "rouge":
        HexColor = "#ae2012";
        break;
      case "bleuMarine":
        HexColor = "#002855";
        break;
      case "bleuLight":
        HexColor = "#0353a4";
        break;
      case "vert":
        HexColor = "#2b9348";
        break;
      case "rose":
        HexColor = "#e5989b";
        break;
      case "marron":
        HexColor = "#9d6b53";
        break;
      case "orange":
        HexColor = "#ff9100";
        break;
      case "jaune":
        HexColor = "#ffa200";
        break;
      case "violet":
        HexColor = "#9d4edd";
        break;
      case "rouge":
        HexColor = "#ae2012";
        break;
      default:
        HexColor = "#2b9348";
    }

    return HexColor
  };